import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const QuoteIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 30,
  height = 30,
  ...rest
}) => {
  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g id="Quote">
          <path
            d="M0,15 C0,23.284 6.716,30 15,30 C23.284,30 30,23.284 30,15 C30,6.716 23.284,0 15,0 C6.716,0 0,6.716 0,15"
            fill="#FF4D52"
            id="Fill-1"
          ></path>
          <path
            d="M15.0814,5.6512 C10.0654,5.6512 6.0004,9.7172 6.0004,14.7322 C6.0004,16.2642 6.3824,17.7042 7.0524,18.9702 L5.5274,23.7982 C5.4414,24.0692 5.6964,24.3262 5.9684,24.2422 L10.8214,22.7512 C12.0924,23.4282 13.5414,23.8142 15.0814,23.8142 C20.0974,23.8142 24.1624,19.7482 24.1624,14.7322 C24.1624,9.7172 20.0974,5.6512 15.0814,5.6512"
            fill="#ffffff"
            className={styles.white}
            id="Fill-3"
          ></path>
          <path
            d="M14.4816,13.8211 L14.4816,13.8211 C14.5496,12.6861 13.6836,11.7011 12.5306,11.6151 C11.3676,11.5291 10.3556,12.3891 10.2696,13.5381 C10.1846,14.6861 11.0586,15.6871 12.2216,15.7731 C12.3516,15.7831 12.4796,15.7771 12.6056,15.7641 C12.0796,16.9161 11.1216,17.9021 11.1216,17.9021 C14.7836,16.1321 14.4816,13.8211 14.4816,13.8211"
            fill="#FF4D52"
            id="Fill-5"
          ></path>
          <path
            d="M19.8228,13.8211 L19.8228,13.8211 C19.8908,12.6861 19.0248,11.7011 17.8718,11.6151 C16.7088,11.5291 15.6968,12.3891 15.6108,13.5381 C15.5258,14.6861 16.3998,15.6871 17.5628,15.7731 C17.6928,15.7831 17.8208,15.7771 17.9458,15.7641 C17.4208,16.9161 16.4628,17.9021 16.4628,17.9021 C20.1248,16.1321 19.8228,13.8211 19.8228,13.8211"
            fill="#FF4D52"
            id="Fill-7"
          ></path>
        </g>
      </g>
    </Icon>
  )
}
